import React from "react";
import { Button } from "@/components/ui/button";
import { PeriodPreset } from "../../hooks/usePeriodReportBuilder";

interface PeriodSelectorProps {
  selectedPeriod: PeriodPreset;
  onPeriodChange: (period: PeriodPreset) => void;
  onGenerateReport: () => void;
  canGenerate: boolean;
  loading: boolean;
}

export const PeriodSelector: React.FC<PeriodSelectorProps> = ({
  selectedPeriod,
  onPeriodChange,
  onGenerateReport,
  canGenerate,
  loading,
}) => {
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center gap-2 bg-gray-100 p-2 rounded-lg">
        <Button
          className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap
            ${
              selectedPeriod === "current_month"
                ? "bg-white shadow text-black hover:bg-gray-50"
                : "text-gray-500 hover:bg-gray-200"
            }`}
          onClick={() => onPeriodChange("current_month")}
          type="button"
          variant="ghost"
        >
          Current Month
        </Button>

        <Button
          className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap
            ${
              selectedPeriod === "last_month"
                ? "bg-white shadow text-black hover:bg-gray-50"
                : "text-gray-500 hover:bg-gray-200"
            }`}
          onClick={() => onPeriodChange("last_month")}
          type="button"
          variant="ghost"
        >
          Last Month
        </Button>

        <Button
          className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap
            ${
              selectedPeriod === "current_year"
                ? "bg-white shadow text-black hover:bg-gray-50"
                : "text-gray-500 hover:bg-gray-200"
            }`}
          onClick={() => onPeriodChange("current_year")}
          type="button"
          variant="ghost"
        >
          Current Year
        </Button>

        <Button
          className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap
            ${
              selectedPeriod === "last_year"
                ? "bg-white shadow text-black hover:bg-gray-50"
                : "text-gray-500 hover:bg-gray-200"
            }`}
          onClick={() => onPeriodChange("last_year")}
          type="button"
          variant="ghost"
        >
          Last Year
        </Button>

        <Button
          className="ml-auto"
          disabled={!canGenerate || loading}
          onClick={onGenerateReport}
          type="button"
        >
          {loading ? "Generating..." : "Generate Report"}
        </Button>
      </div>
    </div>
  );
};
